import { render } from "./JobsDetail.vue?vue&type=template&id=15382a87"
import script from "./JobsDetail.vue?vue&type=script&lang=js"
export * from "./JobsDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__